module.exports = __webpack_public_path__ + "static/media/CN.af7d7d1e.png";